import { render, staticRenderFns } from "./registerSucces.vue?vue&type=template&id=bd2a6254&scoped=true&"
import script from "./registerSucces.vue?vue&type=script&lang=js&"
export * from "./registerSucces.vue?vue&type=script&lang=js&"
import style0 from "./registerSucces.vue?vue&type=style&index=0&id=bd2a6254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2a6254",
  null
  
)

export default component.exports